
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      title: this.$t('jobs.title')
    }
  },
  head () {
    return {
      title: this.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('jobs.description')
        }
      ]
    }
  },
  computed: {
    ...mapState('customer', ['customer'])
  },
  mounted () {
    const join = document.createElement('script')

    join.src =
      'https://join.com/api/widget/bundle/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZXR0aW5ncyI6eyJzaG93Q2F0ZWdvcnlGaWx0ZXIiOnRydWUsInNob3dMb2NhdGlvbkZpbHRlciI6dHJ1ZSwic2hvd0VtcGxveW1lbnRUeXBlRmlsdGVyIjp0cnVlLCJsYW5ndWFnZSI6ImRlIiwiam9ic1BlclBhZ2UiOjI1fSwiam9icyI6e30sImRlc2lnbiI6eyJzaG93TG9nbyI6dHJ1ZSwic2hvd0xvY2F0aW9uIjp0cnVlLCJzaG93RW1wbG95bWVudFR5cGUiOnRydWUsInNob3dDYXRlZ29yeSI6dHJ1ZSwiY29sb3JzIjp7IndpZGdldCI6eyJiYWNrZ3JvdW5kIjoiI0ZGRkZGRiIsImZpbHRlckJvcmRlciI6IiNEMEQ0REEiLCJwYWdpbmF0aW9uIjoiIzJBNzNGRiJ9LCJqb2JDYXJkIjp7InNoYWRvdyI6IiNEMEQ0REEiLCJiYWNrZ3JvdW5kIjoiI0ZGRkZGRiIsInByaW1hcnlUZXh0IjoiIzM2M0Y0QSIsInNlY29uZGFyeVRleHQiOiIjNUY2ODc1In19fSwidmVyc2lvbiI6MiwiY29tcGFueVB1YmxpY0lkIjoiYTcyZGVlOWYyNWE5ZGJhMzgxNmViYjE1N2U4NTI3ODciLCJpYXQiOjE2NDYxNzAxNTUsImp0aSI6Ijg4YjhlYzljLTBmZmEtNGRhZC05NmUzLTUzMzUwNzRmMjM2NSJ9.weqYvl7zIvvj9JFObd45nRaeaFd1uqCENO1zKqudgKA'
    join.defer = true
    join.attributes['data-mount-in'] = '#join-widget'

    const joinWidget = document.getElementById('join-widget')
    if (!joinWidget) { return }

    const parent = joinWidget.parentNode
    if (!parent || parent.nodeType !== Node.ELEMENT_NODE) { return }

    joinWidget.parentNode.insertBefore(join, joinWidget.nextSibling)

    this.collect({
      action: 'view'
    })
  },
  methods: {
    ...mapActions('useractionlog', ['collect'])
  }
}
